import {
  REQUEST_MESSAGES,
  RESPONSE_MESSAGES,
  REQUEST_MESSAGES_FAILURE,
  SET_MESSAGES_TABLE_DATA,
  SET_MESSAGES_PAGE,
  SET_CURRENT_MESSAGE_INDEX,
  SET_MESSAGES_TABLE_PAGE_DATA,
  CLEAR_MESSAGES,
  SET_MESSAGES_TABLE_SCROLL
} from '../actions/messagesActions'

import { states } from './queriesStates'

const initialState = {
  dataState: states.NOT_REQUESTED,
  count: 0,
  data: [],
  errors: [],
  tableData: [],
  page: 1,
  currentIndex: 0,
  tablePageData: {},
  tableScroll: 0
}

const messagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_MESSAGES:
      return Object.assign(
        {},
        state,
        {
          dataState: states.REQUEST
        }
      )
    case RESPONSE_MESSAGES:
      const { count, data, tableData } = action.payload

      return Object.assign(
        {},
        state,
        {
          dataState: states.READY,
          count: count,
          data: data,
          tableData: tableData,
          page: 1,
          errors: []
        }
      )
    case REQUEST_MESSAGES_FAILURE:
      return Object.assign(
        {},
        state,
        {
          dataState: states.FAILURE,
          errors: action.errors
        }
      )
    case SET_MESSAGES_TABLE_DATA:
      return Object.assign(
        {},
        state,
        {
          tableData: action.data
        }
      )
    case SET_MESSAGES_PAGE:
      return Object.assign(
        {},
        state,
        {
          page: action.data
        }
      )
    case SET_CURRENT_MESSAGE_INDEX:
      return Object.assign(
        {},
        state,
        {
          currentIndex: action.data
        }
      )
    case SET_MESSAGES_TABLE_PAGE_DATA:
      return Object.assign(
        {},
        state,
        {
          tablePageData: action.data
        }
      )
    case CLEAR_MESSAGES:
      return Object.assign(
        {},
        state,
        initialState
      )
    case SET_MESSAGES_TABLE_SCROLL:
      return Object.assign(
        {},
        state,
        {
          tableScroll: action.data
        }
      )
    default:
      return state
  }
}

export default messagesReducer